import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';

import LoadingScreen from '../../../Ui/LoadingScreen/LoadingScreen';

import classes from './ProcessOptimizationAdvisor.module.css';
import { pushToError } from '../../../../utils/common';
class ProcessOptimizationAdvisor extends Component {
  state = {
    htmlApiLoading: true,
  };
  componentDidMount() {
    this.props.setCurrentRouteState('tp/advisor', 'Process Optimization');
    if (!this.props.userfleetApiLoading) {
      $('.' + classes.ProcessOptimizationAdvisor).load(
        '/html/angularContainer.html',
        () => {
          const url = `${this.props.settings.server}tp/tp.static/html/tp_recommendations.html`;
          axios
            .get(url, {
              headers: { Authorization: `Bearer ${this.props.settings.token}` },
            })
            .then((response) => {
              $('#angularContainer').load(window.makeTextFile(response.data));
              this.setState({
                htmlApiLoading: false,
              });
            })
            .catch((err) => {
              console.error(err);
              pushToError(this.props,this.state.pname,err,url);
            });
        }
      );
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.userfleetApiLoading !== this.props.userfleetApiLoading) {
      this.setState({
        htmlApiLoading: true,
      });
      $('.' + classes.ProcessOptimizationAdvisor).load(
        '/html/angularContainer.html',
        () => {
          const url = `${this.props.settings.server}tp/tp.static/html/tp_recommendations.html`;
          axios
            .get(url, {
              headers: { Authorization: `Bearer ${this.props.settings.token}` },
            })
            .then((response) => {
              $('#angularContainer').load(window.makeTextFile(response.data));
              this.setState({
                htmlApiLoading: false,
              });
            })
            .catch((err) => {
              console.error(err);
              pushToError(this.props,this.state.pname,err,url);
            });
        }
      );
    }
  }
  render() {
    return (
      <React.Fragment>
        {this.state.htmlApiLoading || this.props.userfleetApiLoading ? (
          <LoadingScreen />
        ) : null}
        <div className={classes.ProcessOptimizationAdvisor}></div>
      </React.Fragment>
    );
  }
}

export default ProcessOptimizationAdvisor;
